import { Model } from '@vuex-orm/core'
import type { LangedItem } from '../common/commons'

export default class HotelAmenities extends Model {
  declare roomID: number
  declare icon: string
  declare id: number
  declare pricingType: number
  declare type: number
  declare description: LangedItem[]
  declare totalAmount: number
  declare hotelID: number

  static entity = 'hotelAmenities'
  static primaryKey = 'id'

  static fields() {
    return {
      roomID: this.attr(null),
      icon: this.attr(null),
      id: this.attr(null),
      pricingType: this.number(0),
      type: this.number(0),
      description: this.attr(null).nullable(),
      totalAmount: this.number(0),
      hotelID: this.attr(null),
    }
  }

  get tooltip() {
    return this.description ? this.description[0].value : ''
  }
}
